var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSkiLoading)?_c('div',{staticClass:"skiMask"},[_c('img',{attrs:{"src":require("@/assets/images/skiLogo.png"),"alt":"AllEat"}}),_c('div',{staticClass:"desc"},[_vm._v("Loading ...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }